import React, { Component } from "react";
import { DataGridContainer } from "app/modules/common/grid/data-grid-container";
import { DataGridHeader } from "app/modules/common/grid/data-grid-header";
import { Button, Grid, InputBase } from "@mui/material";
import { DataGridBody } from "app/modules/common/grid/data-grid-body";
import { DataGridPro, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { inject, provider } from "react-ioc";
import { observer } from "mobx-react";
import { IntegrationsStore } from "app/modules/company/components/integrations/IntegrationsStore";
import { Link } from "react-router-dom";
import { NavigationStore } from "app/modules/company/stores/NavigationStore";
import { PageTitleChip } from "app/modules/common/layout/components/page-title";
import { BoxCenter } from "app/modules/common/layout/components/containers";
import { SearchPaper, SearchVerDivider } from "app/modules/common/layout/components/search";
import { DateTimeHelper } from "app/modules/common/helpers/DateTimeHelper";
import {
    IntegrationListModel,
    TenantClaims,
    IntegrationType
} from "app/modules/company/api/clients.api";
import { Loading } from "app/modules/common/layout/components/loading";
import { StringHelper } from "app/modules/common/helpers/StringHelper";
import { Paths } from "app/modules/company/stores/paths";
import { BtnLink } from "app/modules/common/layout/components/btn-link";
import { MainStore } from "app/modules/company/stores/MainStore";
import { StatusBadge } from "app/modules/common/layout/components/status-badge";

export const IntegrationTypeMap = new Map<IntegrationType, string>([
    [IntegrationType.KeepTruckin, "Gomotive"],
    [IntegrationType.Samsara, "Samsara"],
    [IntegrationType.Geotab, "Geotab"],
    [IntegrationType.Linxup, "Linxup"]
]);


const columns = [
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 250,
        flex: 2,
        renderCell: (params: GridRenderCellParams<IntegrationListModel>) => (
            <Link to={Paths.EditIntegration.nav(params.row.id)}>{params.row.name}</Link>
        ),
    },
    {
        field: 'carrierName',
        headerName: 'Carrier',
        minWidth: 250,
        flex: 2,
        renderCell: (params: GridRenderCellParams<IntegrationListModel>) => (
            StringHelper.formatNull(params.row.carrierName)
        ),
    },
    {
        field: 'type',
        headerName: 'Type',
        minWidth: 200,
        flex: 1,
        renderCell: (params: GridRenderCellParams<IntegrationListModel>) => (
            IntegrationTypeMap.get(params.row.type)
        ),
    },
    {
        field: 'vehicles',
        headerName: 'Vehicles',
        minWidth: 100,
        flex: 1
    },
    {
        field: 'drivers',
        headerName: 'Drivers',
        minWidth: 100,
        flex: 1
    },
    {
        field: 'createdAt',
        headerName: 'CreatedAt',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<IntegrationListModel>) => (
            DateTimeHelper.formatMomentDate(params.row.createdAt)
        ),
    },
    {
        field: 'status',
        headerName: 'Status',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<IntegrationListModel>) => (
            <StatusBadge active={params.row.active} />
        )
    }
];

@provider(IntegrationsStore)
@observer
export default class Index extends Component<any, any> {
    @inject integrationsStore: IntegrationsStore;
    @inject navigationStore: NavigationStore;
    @inject mainStore: MainStore;

    render() {
        if (this.integrationsStore.isInitLoading) {
            return <Loading />;
        }

        return <DataGridContainer>
            <Grid item xs={this.mainStore.checkClaim(TenantClaims.IntegrationEdit) ? 6 : 12}>
                <PageTitleChip Title={this.navigationStore.title} TotalRows={this.integrationsStore.totalRows} />
            </Grid>
            {this.mainStore.checkClaim(TenantClaims.IntegrationEdit) && <Grid item xs={6} textAlign={"right"}>
                <BtnLink Link={Paths.NewIntegration.nav} Text="New Integration" />
            </Grid>}
            <DataGridHeader>
                <BoxCenter>
                    <SearchPaper width={400}>
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            value={this.integrationsStore.filters.$.search.value}
                            onChange={(e) => this.integrationsStore.filters.$.search.onChange(e.target.value)}
                            placeholder="Search"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                        <SearchVerDivider />
                        <Button variant="text" onClick={this.integrationsStore.applyFilters}>Search</Button>
                    </SearchPaper>
                </BoxCenter>
            </DataGridHeader>
            <DataGridBody>
                <DataGridPro
                    disableVirtualization
                    rows={this.integrationsStore.items}
                    columns={columns}
                    pageSize={this.integrationsStore.pageSize}
                    rowsPerPageOptions={this.integrationsStore.pageSizeOptions}
                    rowCount={this.integrationsStore.totalRows}
                    page={this.integrationsStore.skipRows / this.integrationsStore.pageSize}
                    loading={this.integrationsStore.isLoading}
                    pagination
                    paginationMode="server"
                    disableColumnFilter
                    disableColumnSelector
                    disableSelectionOnClick
                    checkboxSelection={false}
                    onPageChange={(page) => this.integrationsStore.setPage(page)}
                    onPageSizeChange={(pageSize) => this.integrationsStore.setPageSize(pageSize)} />
            </DataGridBody>
        </DataGridContainer>;
    }

    componentDidMount() {
        this.integrationsStore.init();
    }
}

